export default "__VITE_ASSET__dbaa0b68__"